import { render } from "./BookList.vue?vue&type=template&id=d58ee734&scoped=true"
import script from "./BookList.vue?vue&type=script&lang=js"
export * from "./BookList.vue?vue&type=script&lang=js"

import "./BookList.vue?vue&type=style&index=0&id=d58ee734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d58ee734"]])

export default __exports__